<template>
    <div class="bg-white">
        <Mainlayout></Mainlayout>
        <CCol sm="12" style="background-size: cover;" :style="{ backgroundImage: `url(${backgroundUrl})` }">
            <CCol sm="12" lg="12">
                <CRow>
                    <CCol sm="12" lg="12">
                        <div style="margin: 5%">
                            <div class="text-center">
                                <br /><br /><br />
                                <h1 class="custom-text-aladdin text-black poppin-font custom-52px-600">
                                    Welcome to Creative Insights, where <br /> your videos meet the power of <br /> AI-driven analysis.
                                </h1>
                                <p class="custom-16px-400 text-center ml-4 font-color-737373">Our platform evaluates your content to identify strengths and areas for improvement, providing actionable suggestions <br />
                                    to enhance engagement, creativity, and reach. Simply upload your video, and let our advanced tools analyze <br />
                                    performance metrics, audience impact, and content effectiveness. Whether you’re a budding creator or an established </p>
                            </div>
                        </div>
                        <br />
                    </CCol>
                </CRow>
            </CCol>
        </CCol>
        <CCol sm="12" class="bg-FAFAFA">
            <CContainer>
                <br /><br />
                <h3 class="custom-24px-500 text-center">
                    Please Select One Of The Option
                </h3>

                <br /><br />
                <CRow class="d-flex">
                    <CCol sm="4" class="d-flex">
                        <CCard class="bg-white b-20 p-20 text-center custom-border-e5e5e5 flex-grow-1">
                            <div class="text-center">
                            <img src="../assets/img/smallicon/chart.png" style="width:30px" class="m-4" />
                            <h3 class="custom-16px-600 text-center ml-4">
                                Marketing improvement
                            </h3>
                            <p class="custom-14px-400 text-left ml-4 font-color-98A2B3">
                                Enhance your video’s appeal, messaging, and engagement for better marketing results</p>
                            </div>
                            </CCard>
                    </CCol>
                    <CCol sm="4" class="d-flex">
                        <CCard class="bg-white b-20 p-20 text-center custom-border-e5e5e5 flex-grow-1">
                            <div class="text-center">
                            <img src="../assets/img/smallicon/user-octagon.png" style="width:30px" class="m-4" />
                            <h3 class="custom-16px-600 text-center ml-4">
                                Personal Branding
                            </h3>
                            <p class="custom-14px-400 text-left ml-4 font-color-98A2B3">
                                Build a strong and unique personal brand through creativity and effective delivery.</p>
                            </div>
                            </CCard>
                    </CCol>
                    <CCol sm="4" class="d-flex">
                        <CCard class="bg-white b-20 p-20 text-center custom-border-e5e5e5 flex-grow-1">
                            <div class="text-center">
                            <img src="../assets/img/smallicon/bag.png" style="width:30px" class="m-4" />
                            <h3 class="custom-16px-600 text-center ml-4">
                                Sales of product
                            </h3>
                            <p class="custom-14px-400 text-left ml-4 font-color-98A2B3">
                                Optimize your video to boost product sales with better CTAs and audience appeal.</p>
                            </div>
                            </CCard>
                    </CCol>
                </CRow>
            </CContainer>
            <CContainer class="mt-4">
                <h3 class="custom-16px-500 text-left font-color-212529">Upload your video</h3>
                <CCard
                    class="custom-border-dashed-928AFD"
                    style="max-height: 500px; display: flex; flex-direction: column; align-items: center; justify-content: center; overflow: hidden;"
                >
                    <div class="mt-5 mb-5 text-center" style="width: 100%; overflow: hidden;">
                        <img
                            src="../assets/img/smallicon/folder-open.png"
                            style="width: 50px; max-width: 100%; height: auto;"
                        />
                        <br />
                        <div v-if="videoPreviewUrl" class="mt-4">
                            <video
                                :src="videoPreviewUrl"
                                controls
                                style="max-width: 100%; max-height: 400px; border: 1px solid #ccc; border-radius: 8px;"
                            ></video>
                        </div>
                            <span class="font-color-6941C6" @click="triggerFileInput">
                                Click to upload
                            </span>
                            <span class="font-color-696969"><br />
                                Mp4 (max. 10MB, max. 30 seconds)
                            </span>
                        </div>
                        <input
                            type="file"
                            accept="video/mp4"
                            ref="fileInput"
                            @change="onFileChange"
                            style="display: none;"
                        />
                </CCard>
                <h3 class="custom-16px-500 text-left font-color-212529">Description</h3>
                <CTextarea
                placeholder="Content..."
                v-model="description"
                vertical
                rows="9"
              />
              <h3 class="custom-16px-500 text-left font-color-212529">Voice Script</h3>
              <CInput type="text" />
              <div class="text-right mb-5">
                <CButton type="button" class="bg-D0D5DD font-color-737373 border-radius-half" @click="submitVideo">Suggest me</CButton>
              </div>
              <br />
            </CContainer>
        </CCol>
        <Footerlayout></Footerlayout>
    </div>
</template>


<script>
import Vue from "vue";
import AOS from "aos";
import "aos/dist/aos.css";

import backgroundUrl from "../assets/img/bgPurpleYellow.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundMap from "../assets/img/Map.png";
import backgroundUrlTestimoni from "../assets/img/bgBluesquare.png";

import Mainlayout from "../containers/AllHeader.vue";
import MainlayoutLogin from "../containers/LoginHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import ToggleCard from '../components/Toggle.vue';
import backgroundUrNoArrow from "../assets/img/bgline.png";

export default {
    name: "Login",
    components: {
        Mainlayout,
        MainlayoutLogin,
        Footerlayout,
        ToggleCard
    },

    data() {
        return {
            backgroundUrl,
            backgroundUrl1,
            backgroundMap,
            backgroundUrlTestimoni,
            isActive: false,
            backgroundUrNoArrow,

            Names: "",
            loading: true,
            videoPreviewUrl: null,
            description: "",


        };
    },
    created() {
        AOS.init();
    },
    mounted() {
        try {
        const isAuth = this.UserAuth();
        if (isAuth) {
            this.GetInfoUser();
        } else {
                this.GoToLogin();
            }
        } catch (error) {
            this.GoToLogin();
            console.error("Error during authentication:", error);
            // Handle the error here
        }

    },
    methods: {
      
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, { withCredentials: true });
                if (response.status === 200 && response.data) {
                    this.user = response.data;
                    this.Names = this.user.name;
                } else {
                    console.error("User info retrieval failed:", response.data.detail);
                }
            } catch (error) {
                console.error("Error fetching user info:", error);
            }
        },
        triggerFileInput() {
            this.$refs.fileInput.click();
        },

        async onFileChange(event) {
        const file = event.target.files[0];

        if (!file) {
            alert("No file selected.");
            return;
        }

        // Reset the video preview URL to prepare for new video
        this.videoPreviewUrl = null;

        // Check file size
        if (file.size > 10 * 1024 * 1024) {
            alert("File size exceeds 10MB.");
            this.clearVideo();
            return;
        }

        // Validate video duration
        const isValid = await this.validateVideoDuration(file);
        if (!isValid) {
            alert("Video duration exceeds 30 seconds.");
            this.clearVideo();
            return;
        }

        // Generate a preview URL and set it in data
        this.videoPreviewUrl = URL.createObjectURL(file);
        console.log("New video uploaded:", this.videoPreviewUrl);
        alert("File is valid! Preview available.");
        },

        validateVideoDuration(file) {
            return new Promise((resolve) => {
                const video = document.createElement("video");
                video.preload = "metadata";

                video.onloadedmetadata = function () {
                    window.URL.revokeObjectURL(video.src);
                    resolve(video.duration <= 30); // Check if duration is within limit
                };

                video.onerror = function () {
                    alert("Invalid video file.");
                    resolve(false);
                };

                video.src = URL.createObjectURL(file);
            });
        },

        clearVideo() {
            // Clear the video preview and reset the file input
            this.videoPreviewUrl = null;
            this.$refs.fileInput.value = null; // Reset file input
        },
        GoToLogin() {
            let path = this.$router.currentRoute.path;
            if (path.toLowerCase() != "/Login") {

                this.$router.push({
                    path: '/Login',
                    query: {
                        targetUrl: this.$router.currentRoute.fullPath,
                    }
                })

            }
        },
        onFileChange(event) {
      const file = event.target.files[0];
      if (file && file.type === "video/mp4" && file.size <= 10 * 1024 * 1024) {
        this.videoPreviewUrl = URL.createObjectURL(file); // Display video preview
        this.videoFile = file; // Save the file for API upload
      } else {
        alert("Please upload a valid MP4 video (max 10MB).");
      }
    },
    async submitVideo() {
      // Validate inputs
      if (!this.videoFile) {
        alert("Please upload a video.");
        return;
      }
      if (!this.description.trim()) {
        alert("Please add a description.");
        return;
      }

      try {
        // Prepare form data
        const formData = new FormData();
                formData.append("file", this.videoFile);
                formData.append("Description", this.description);
                formData.append("userId", this.user.id);

                try {
                    const response = await this.$API.post(this.$UploadVideoCreativeInsight, formData, {
                       
                    });

                    if (response.status === 200) {
                        this.videoId = response.data.videoId;
                        console.log("Successfully uploaded.");
                        await this.retryOperation(() => this.InsertVideoText(this.videoId));
                    } else {
                        console.error("Failed to upload.");
                    }
                } catch (error) {
                    console.error("Error during upload:", error);
                }

        // Handle successful response
        if (response.status === 200 || response.status === 201) {
          alert("Video submitted successfully!");
          this.resetForm();
        } else {
          alert("Submission failed. Please try again.");
        }
      } catch (error) {
        // Handle errors
        console.error(error);
       // alert("An error occurred while submitting the video. Please try again.");
      }
    },
    },

};
</script>